import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";

export const hideOnDesktopView = css`
  ${MEDIA_QUERY_FOR_PC} {
    display: none;
  }
`;

export const infoWrapperStyle = css`
  display: flex;
  flex-direction: column;
  row-gap: 8px;
`;

export const infoTitleTextStyle = css`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`;

export const infoDetailTextStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const infoOptionalTextStyle = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: #757575;
`;

const baseButtonStyle = css`
  display: flex;
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 1px solid #000;
  cursor: pointer;
  /* buttonのフォントに関するCSS*/
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
`;

export const blackBaseButtonStyle = css`
  ${baseButtonStyle};
  background-color: #000;
  color: #fff;
`;

export const whiteBaseButtonStyle = css`
  ${baseButtonStyle};
  background-color: transparent;
  color: #000;
`;
